import React, {useEffect, useState} from "react";
import {Typography, Flex} from "antd";
import style from './style.module.scss'
import {BusinessIcon, CargoIcon, DashboardArrow, EntrepreneurIcon, LineIcon} from "@/theme/assets/icons";
import {useTranslations} from "next-intl";


export const InfoUsers = ({users}) => {
    const t = useTranslations('dashboard.users');
    const [isEntrepreneurDifference, setIsEntrepreneurDifference] = useState(false);
    const [isBusinessDifference, setIsBusinessDifference] = useState(false);
    const [isCargoDifference, setIsCargoDifference] = useState(false);

    useEffect(() => {
        users?.entrepreneur_difference_count > 0 ? setIsEntrepreneurDifference(true) : setIsEntrepreneurDifference(false)
        users?.business_difference_count > 0 ? setIsBusinessDifference(true) : setIsBusinessDifference(false)
        users?.cargo_difference_count > 0 ? setIsCargoDifference(true) : setIsCargoDifference(false)
    }, [users]);

    return (
        <>
            <Flex
                gap={20}
                justify={"space-between"}
                className={style.users_blocks}
            >
                <div className={style.card}>
                    <Flex
                        justify={'space-between'}
                        wrap
                    >
                        <Typography.Title
                            level={4}
                            className={style.title}
                        >
                            {t('entrepreneur')}
                        </Typography.Title>
                        <EntrepreneurIcon />
                    </Flex>
                    <Flex
                        align={'center'}
                    >
                        <div className={style.count_users}>
                            {users?.entrepreneur_count ?? 0}
                        </div>
                        <LineIcon />
                        <Flex
                            vertical
                            style={{paddingLeft: '15px'}}
                        >
                            <div className={style.statistic}>
                                <span>{users?.entrepreneur_difference_count ?
                                    users?.entrepreneur_difference_count + '%' : 0}</span>
                                <DashboardArrow
                                    className={!isEntrepreneurDifference ? 'rotate_arrow' : 'arrow'}
                                />
                            </div>
                            <div className={style.description}>
                                {t('last_month')}
                            </div>
                        </Flex>
                    </Flex>
                </div>
                <div className={style.card}>
                    <Flex
                        justify={'space-between'}
                        wrap
                    >
                        <Typography.Title
                            level={4}
                            className={style.title}
                        >
                            {t('business')}
                        </Typography.Title>
                        <BusinessIcon />
                    </Flex>
                    <Flex
                        align={'center'}
                    >
                        <div className={style.count_users}>
                            {users?.business_count ?? 0}
                        </div>
                        <LineIcon />
                        <Flex
                            vertical
                            style={{paddingLeft: '15px'}}
                        >
                            <div className={style.statistic}>
                                <span>{users?.business_difference_count ?
                                    users?.business_difference_count + '%' : 0}</span>
                                <DashboardArrow
                                    className={!isBusinessDifference ? 'rotate_arrow' : 'arrow'}
                                />
                            </div>
                            <div className={style.description}>
                                {t('last_month')}
                            </div>
                        </Flex>
                    </Flex>
                </div>
                <div className={style.card}>
                    <Flex
                        justify={'space-between'}
                        wrap
                    >
                        <Typography.Title
                            level={4}
                            className={style.title}
                        >
                            {t('cargo')}
                        </Typography.Title>
                        <CargoIcon />
                    </Flex>
                    <Flex
                        align={'center'}
                    >
                        <div className={style.count_users}>
                            {users?.cargo_count ?? 0}
                        </div>
                        <LineIcon />
                        <Flex
                            vertical
                            style={{paddingLeft: '15px'}}
                        >
                            <div className={style.statistic}>
                                <span>{users?.cargo_difference_count ?
                                    users?.cargo_difference_count + '%' : 0}</span>
                                <DashboardArrow
                                    className={!isCargoDifference ? 'rotate_arrow' : 'arrow'}
                                />
                            </div>
                            <div className={style.description}>
                                {t('last_month')}
                            </div>
                        </Flex>
                    </Flex>
                </div>
            </Flex>
        </>
    );
}